export default __webpack_public_path__ + "static/media/save-query.332c38fa.png";